<template>
  <div id="app">
    <Header :mobile="$store.state.MobileStatue"></Header>
    <router-view :mobile="$store.state.MobileStatue"></router-view>
    <Footer :mobile="$store.state.MobileStatue"></Footer>
    <CookieConsentTool ref="cookieConsentTool" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Header from './components/common/header'
import Footer from './components/common/footer'
import CookieConsentTool from './components/common/CookieConsentTool'

export default {
  name: 'App',
  data(){
    return{
    }
  },
   components: {
    Header,
    Footer,
    CookieConsentTool,
  },
  computed: {
    ...mapGetters(["MobileStatue"])
  },
   methods: {
     
    },
    mounted(){
      this.$store.commit('getMobileStatue')
      var _this = this;
      window.onresize = () => {
        _this.$store.commit('getMobileStatue')
      }
      
      // 监听来自 footer 的打开 Cookie Consent Tool 事件
      this.$root.$on('openCookieConsent', () => {
        if (this.$refs.cookieConsentTool) {
          this.$refs.cookieConsentTool.openCookieConsent();
        }
      });
    },
    beforeDestroy() {
      this.$root.$off('openCookieConsent');
    }
}
</script>

<style lang="scss">
* {
    padding: 0;
    margin: 0;
}
body,
html {
    overflow-Y: auto; 
    overflow-x: hidden;
    width: 100%;
    height: 100%;
}
#app {
    height: 100%;
}
.clearfix {
  zoom: 1;
}
.clearfix:after {
  content: " ";
  display: block;
  height: 0;
  clear: both;
}
  .el-select-dropdown__wrap{
    max-height:200PX!important;
  }
  .el-select-dropdown__list{
    padding: 10PX 0!important;
  }
  .el-select-dropdown__item{
    font-size: 14PX!important;
    height: 32PX!important;
    line-height: 32PX!important;
    padding: 0 25PX!important;
  }
  .el-message{
    padding: 10PX 20PX 20PX!important;
    border:1px solid #ebeef5!important;
    font-size: 14PX!important;
    min-width: 300PX!important;
    left:20PX;
    i{
      font-size: 16PX!important;
    }
    p{
      font-size: 14PX!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue